<template>
  <div :class="b()" :style="styleSizeName">
    <div v-show="hasData" :ref="id" :style="styleChartName"></div>
    <template v-if="!hasData">
      <empty></empty>
    </template>
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'sunburst',
  mixins: [init],
  computed: {
    x2() {
      return this.option.gridX2 || 90;
    },
    hasData() {
      return this.dataChart?.series;
    }
  },

  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart) || [];
      const levels = [{}];
      for (let i = 0; i < this.option.barColor.length; i++) {
        const obj = {
          itemStyle: this.ishasprop(
            !this.switchTheme,
            {
              color: this.getColor(i)
            },
            {}
          )
        };
        levels.push(obj);
      }
      const option = {
        title: this.ishasprop(
          this.option.titleShow,
          {
            text: this.option.title,
            subtext: this.option.subtext || '',
            textStyle: {
              color: this.option.titleColor || '#333',
              fontSize: this.option.titleFontSize || 16
            },
            left: this.option.titlePostion || 'auto',
            subtextStyle: {
              color: this.option.subTitleColor || '#aaa',
              fontSize: this.option.subTitleFontSize || 14
            }
          },
          {}
        ),
        tooltip: {
          show: true
        },
        series: (() => {
          const list = [
            {
              type: 'sunburst',
              data: optionData.series.data,
              center: ['50%', '50%'],
              radius: this.option.radius ? [50, '90%'] : '90%',
              label: {
                show: this.vaildData(this.option.labelShow, false), //开启显示
                position: 'inside', //在右方显示,
                align: 'center',
                textStyle: {
                  //数值样式
                  fontSize: this.option.labelShowFontSize || 14,
                  color: this.option.labelShowColor || '#333',
                  fontWeight: this.option.labelShowFontWeight || 500
                }
                // formatter: name => this.getLabelFormatter(name),
              },
              itemStyle: {
                borderWidth: this.option.borderWidth
              },
              levels: levels
            }
          ];
          return list;
        })()
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);

      this.chartClick();
    }
  }
};
</script>
